import { Badge } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import { BodyText } from "@/components/ui/Text";
import type { CodifiedMedication } from "./useAmazonVisitIntake";

export const CiqMedicationSingleRow = ({
  drug,
  onAdd,
  isPending,
  isAdded,
}: {
  drug: CodifiedMedication;
  onAdd: (drug: CodifiedMedication) => void;
  isPending: boolean;
  isAdded: boolean;
}) => (
  <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 py-1 rounded">
    <BodyText size="sm">{drug.drugName}</BodyText>
    {isAdded ? (
      <div className="flex items-center shrink-0" style={{ height: 25 }}>
        <Badge variant="ai">
          <BodyText size="xs">Added</BodyText>
        </Badge>
      </div>
    ) : (
      <Button
        size="xs"
        type="button"
        onClick={() => onAdd(drug)}
        isLoading={isPending}
        className="shrink-0 transition-none bg-button-superclinical text-button-primary border border-ai"
      >
        Add
      </Button>
    )}
  </div>
);
